import React from 'react'
import PropTypes from 'prop-types'

import InputGroup from '../EmailSubscriptionCenter/SignIn/InputGroup.jsx'

function AdditionalInformation({
  compact,
  handleInputChange,
  handleFirmInputChange,
  formValidation,
  formData,
  firms,
}) {
  function renderFirms() {
    return firms.length > 0 ? (
      <datalist id="firms">
        {firms.map((firm, index) => {
          return <option value={firm.firmNm} key={'' + index + firm.firmId} />
        })}
      </datalist>
    ) : null
  }

  return (
    <div className="u-paddingHoriz6gu u-sm-sizeFull">
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="firstNameLegal"
        fieldId="firstNameLegal"
        placeholder="Legal First Name"
        label="Legal First Name"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="firstName"
        fieldId="firstName"
        placeholder="Preferred First Name"
        label="Preferred First Name"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="lastName"
        fieldId="lastName"
        placeholder="Last Name"
        label="Last Name"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleFirmInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="firmName"
        fieldId="firmName"
        placeholder="Firm Name"
        label="Firm Name"
        list="firms"
        compact={compact}
      />
      {renderFirms()}
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="zipCode"
        fieldId="zipCode"
        placeholder="Zip Code"
        label="Zip Code"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="phoneNumber"
        fieldId="phoneNumber"
        placeholder="Phone Number"
        label="Phone Number"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="emailId"
        fieldId="emailId"
        placeholder="Email"
        label="Email"
        compact={compact}
        disabled={true}
      />
    </div>
  )
}

AdditionalInformation.propTypes = {
  compact: PropTypes.bool,
  handleInputChange: PropTypes.func.isRequired,
  handleFirmInputChange: PropTypes.func.isRequired,
  formValidation: PropTypes.object,
  firms: PropTypes.array,
}

export default AdditionalInformation
